var _defs, _circle, _circle2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.74 417.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #549cbe;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #596e85;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 199.85,
    cy: 200.23,
    r: 197.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 353.81,
    cy: 345.62,
    r: 69.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.79,375.93h-69.96c-1.83,0-3.3-1.48-3.3-3.3v-12.2c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v8.9h63.35v-8.9c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v12.2c0,1.82-1.48,3.3-3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.81,355.01c-.66,0-1.31-.2-1.87-.58l-18.06-12.43c-1.5-1.03-1.88-3.09-.85-4.59,1.04-1.5,3.09-1.88,4.6-.85l12.88,8.86v-31.87c0-1.82,1.48-3.3,3.3-3.3s3.3,1.48,3.3,3.3v38.15c0,1.23-.68,2.35-1.77,2.92-.48.25-1.01.38-1.54.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.81,355.01c-1.05,0-2.08-.5-2.72-1.43-1.04-1.5-.65-3.56.85-4.59l18.05-12.43c1.51-1.04,3.56-.65,4.59.85,1.04,1.5.65,3.56-.85,4.59l-18.05,12.43c-.57.39-1.23.58-1.87.58Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H5Db4Z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.12,183.49c1.83-19.87,10.55-35.08,29.1-43.36,21.14-9.44,45.05-2.77,58.87,16.38,2.39,3.31,4.12,5.3,8.94,4.48,24.9-4.25,44.33,10.11,47.94,34.9.15,1.04.4,2.06.66,3.38,3.77.66,7.51.96,11.04,1.99,14.91,4.36,24.68,18.86,23.09,33.9-1.7,16.07-14.35,28.92-30.65,29.05-51.5.41-103,.59-154.49-.01-22.96-.27-39.39-16.66-40.74-38.05-1.24-19.68,12.49-37.38,32.45-41.43,4.41-.89,9.01-.82,13.81-1.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/Icon-Cloud.cb0ad6943252cf4eb23dd7c718eac895.svg";
export { ForwardRef as ReactComponent };